import React from 'react';

const ErrorModel: React.FC = () => {
    return(
        <div className="flex justify-center items-center">
            <span className='text-lg text-red-600 font-outfit font-medium'>Failed to fetch data!</span>
        </div>
    )
}

export default ErrorModel;